import React from "react";
import { Table } from "react-bootstrap";
import DeclarationDetails from "../DeclarationDetails";
import ApproveRejectDeclaration from "../ApproveRejectDeclaration";
import { formatDateEdit } from "../../../../constant/DateFormatEdit";
import { getDeclarationApprovalDownloadAsync } from "../../../../features/helpandassistance/DeclarationSlice";
import { useAppDispatch } from "../../../../app/hooks";
import swal from "sweetalert";
const PendingApprovals = ({
  tData,
  GetDeclarationType,
}: {
  tData: any;
  GetDeclarationType?: any;
}) => {
  const dispatch = useAppDispatch();
  const handleDownload = async () => {
    try {
      const { blob, fileName } = await dispatch(
        getDeclarationApprovalDownloadAsync()
      ).unwrap();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "Declaration.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      // Optional feedback
      // swal('Download started', 'Your file is being downloaded.', 'success');
    } catch (err: any) {
      console.error("Download failed:", err);
      swal("Download failed", "Unable to download the report.", "error");
    }
  };
  return (
    <>
      <div className="d-flex justify-content-end">
        <button
          className="button"
          onClick={handleDownload}
          style={{
            padding: "10px 15px",
            fontFamily: "Saira",
            fontSize: "12px",
            fontWeight: 500,
            fontStretch: "normal",
            fontStyle: "normal",
            width: "auto",
          }}
        >
          DOWNLOAD DECLARATION{" "}
        </button>
      </div>

      <Table style={styles.border} responsive>
        <tr style={styles.border}>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Name
          </th>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Token No.
          </th>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Designation
          </th>
          {/* <th className="py-3 ps-3" style={styles.tableHeading}>
            Department
          </th> */}
          {/* <th className="py-3 ps-3" style={styles.tableHeading}>
            Conflict Type
          </th> */}
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Conflict Category
          </th>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Pending From
          </th>
          {/* <th className='py-3 ps-3' style={styles.tableHeading}>
            Sector
          </th> */}
          {/* <th className='py-3 ps-3' style={styles.tableHeading}>
            Office Phone
          </th> */}
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Created On
          </th>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Actions
          </th>
        </tr>

        {tData?.length > 0 ? (
          tData.map((val: any) => {
            return (
              <>
                <tr style={styles.border}>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.name}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.employeeId}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.designation}
                  </td>
                  {/* <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.dept}
                  </td> */}
                  {/* <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.declearationCategoryType}
                  </td> */}
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.conflictCategoryMasterTitle}
                  </td>
                  {/* <td className='py-3 ps-3' style={styles.tableContents}>
                    {val?.officePhone}
                  </td> */}
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.approverMail}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {formatDateEdit(val?.createdDate)
                      ?.split("-")
                      .reverse()
                      .join("-")}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    <div style={{ display: "flex" }}>
                      <DeclarationDetails
                        records={val}
                        GetDeclarationType={GetDeclarationType}
                        type="pending"
                      />
                    </div>
                  </td>
                </tr>
              </>
            );
          })
        ) : (
          <tr style={styles.border}>
            <td className="py-3" style={styles.text1} colSpan={6}>
              No pending declarations
            </td>
          </tr>
        )}
      </Table>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tableHeading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
  },
  tableContents: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
  },
  border: {
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "center",
  },
};

export default PendingApprovals;
